// features/payment/paymentService.ts
import { razorpaypaymentHttp } from "services/axios.services/instances/billerHttp";

export interface CreateRazorpayOrderPayload {
  amount: number; // paise
  currency?: string; // "INR"
  refId: string; // bbps refId
  billerId: string;
}

export interface RazorpayOrderResponse {
  id: string;
  amount: number;
  currency: string;
  receipt?: string;
}

export async function createRazorpayOrder(
  payload: CreateRazorpayOrderPayload,
): Promise<RazorpayOrderResponse> {
  console.warn("pg api not complited");
  // console.log({payload});

  const res = await razorpaypaymentHttp.post(
    "/payments/razorpay/order",
    payload,
  );
  return res.data;
}
